export const findLocationSearch = (search: string, k: string) => {
  const valueArrays = search.split('&').map((arr) => arr.split('='));
  return valueArrays.find((item) => item[0] === k)?.[1];
};
